import React, { useState, useEffect } from "react";
import { Typography, Tag, LoadingSkeleton } from "components";
import { capitalizeFirstLetter, getDataCardColors } from "utils/helper";
import makeRequest from "services/makeRequest";
import { routes } from "routes/apiRoutes";

const PrimaryRoles = () => {
  const [data, setData] = useState({
    roles: [],
    loading: false,
  });

  const { loading, roles } = data;

  useEffect(() => {
    const getRoles = async () => {
      setData((prevState) => ({ ...prevState, loading: true }));
      try {
        const { data } = await makeRequest("get", routes.fetchRoles("predefined=1"));
        setData(() => ({ roles: data.data.content, loading: false }));
      } catch (err) {}
    };
    getRoles();
  }, []);

  const loadingArray = new Array(3).fill();

  return (
    <div className="row primary-roles">
      {loading
        ? loadingArray.map((item, key) => (
            <div className="col-sm-6 col-md-4" key={key}>
              <LoadingSkeleton width={290} height={200} />
            </div>
          ))
        : roles?.map(({ name, description }, key) => {
            let colors = getDataCardColors(name);
            return (
              <div className="col-sm-6 col-md-4" key={key}>
                <div className={`edged-card edged-card--${name.toLowerCase()}`}>
                  <Tag
                    text={capitalizeFirstLetter(name)}
                    backgroundColor={colors?.bgColor}
                    textColor={colors?.textColor}
                  />
                  <Typography className={"mt-4"} variant="body3" state="grey">
                    {description}
                  </Typography>
                </div>
              </div>
            );
          })}
    </div>
  );
};

export default PrimaryRoles;
